import Decimal from 'decimal.js';

export const sumWithDecimal = (precision, firstValue, secondValue, thirdValue) => {
  const firstValueWithDecimal = new Decimal(firstValue);
  const secondValueWithDecimal = new Decimal(secondValue);
  if (thirdValue) {
    return new Decimal(thirdValue)
      .times(firstValueWithDecimal)
      .plus(secondValueWithDecimal)
      .toDecimalPlaces(precision)
      .toNumber();
  }
  return firstValueWithDecimal.plus(secondValueWithDecimal).toDecimalPlaces(precision).toNumber();
};
